import React from "react";

type ButtonColor = "primary" | "secondary" | "danger" | "gray" | "outline";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  type?: "button" | "submit" | "reset";
  color?: ButtonColor;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
};

const colorClasses: Record<ButtonColor, string> = {
  primary: "bg-blue-600 hover:bg-blue-700 text-white",
  secondary: "bg-purple-600 hover:bg-purple-700 text-white",
  danger: "bg-red-600 hover:bg-red-700 text-white",
  gray: "bg-gray-200 hover:bg-gray-300 text-gray-800",
  outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
};

export const Button = ({
  children,
  type = "button",
  color = "primary",
  disabled = false,
  onClick,
  className = "",
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        px-4 py-2 rounded font-medium text-sm
        focus:outline-none focus:ring-2 focus:ring-offset-2
        cursor-pointer
        ${colorClasses[color]}
        ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        ${className}
      `}
    >
      {children}
    </button>
  );
};
